import axios from "axios";
import { refresh, signOut } from "store/slices/authSlice";

import store from "../store";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}`;

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

axiosPrivate.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || "";
      const isAuthEndpoint =
        requestUrl.includes("/auth/") || requestUrl.includes("/users/register");
      if (error.response.data?.errorKey === "E511") {
        store.dispatch(signOut());
      } else if (!isAuthEndpoint && error.response.data?.errorKey === "E510") {
        store.dispatch(refresh());
        // store.dispatch(setRefresh());
      }
    }

    return Promise.reject(error);
  }
);
